module.exports = __webpack_public_path__ + "img/fa-2@3x.3053e452.png";